import React, { useEffect, useState } from "react";
import "../../css/CRUDModal.css";
import { apiList } from "../../helpers/apiList";
import CustomAlert from "../../helpers/CustomAlert";
import { axiosPostApi } from "../../helpers/interceptorServices";
import { formatDateToYYYYMMDD } from "../../helpers/DateHelpers";
import { useDispatch } from "react-redux";
import { setBalance } from "../store/balance/balanceSlice";

const creditsToRupees = (credits) => {
  if (credits === undefined || credits === null || credits === "") return "0.000";
  return (Number(credits) / 1000).toFixed(3);
};

const rupeesToCredits = (rupees) => {
  if (!rupees) return 0;
  return Number(rupees) * 1000;
};

const ClawbackWhatsAppModal = ({
  show,
  handleClose,
  callApi,
  editData,
  action,
  columnData,
}) => {
  const loggedInUserName = sessionStorage.getItem("username");

  const [formData, setFormData] = useState({
    currentWaBalance: "",
    waClawback: "",
    closingWaBalance: "",
  });

  const [errors, setErrors] = useState({
    currentWaBalance: "",
    waClawback: "",
    closingWaBalance: "",
  });

  const dispatch = useDispatch();

  useEffect(() => {
    // Calculate closing balance whenever waClawback changes
    setFormData((prev) => ({
      ...prev,
      closingWaBalance: prev.waClawback
        ? (
            Number(creditsToRupees(columnData?.waBalance || 0)) -
            Number(prev.waClawback || 0)
          ).toFixed(3)
        : "",
    }));
  }, [formData.waClawback, columnData]);

  const handleInputChange = (e) => {
    const { id, value } = e.target;

    let updatedValue = value;

    setFormData((prev) => ({
      ...prev,
      [id]: updatedValue,
    }));
  };

  // Simple validation function
  const validate = () => {
    const newErrors = {};

    if (!formData.waClawback) {
      newErrors.waClawback = "WhatsApp Clawback is required";
    } else {
      if (!/^\d+$/.test(formData.waClawback)) {
        newErrors.waClawback = "Only numbers are allowed for WhatsApp Clawback";
      } else if (parseInt(formData.waClawback, 10) <= 0) {
        newErrors.waClawback = "Amount must be greater than zero";
      } else if (
        Number(formData.waClawback) >
        Number(creditsToRupees(columnData?.waBalance || 0))
      ) {
        newErrors.waClawback =
          "Clawback cannot exceed current WhatsApp balance";
      }
    }

    return newErrors;
  };

  const handleBlur = (e) => {
    const { id, value } = e.target;
    const fieldErrors = {};
    const trimmedValue = value?.trim();

    fieldErrors.waClawback = "";

    if (!trimmedValue) {
      fieldErrors.waClawback = "WhatsApp Clawback is required";
    } else {
      switch (id) {
        case "waClawback":
          if (!/^\d+$/.test(trimmedValue)) {
            fieldErrors.waClawback =
              "Only numbers are allowed for WhatsApp Clawback";
          } else if (parseInt(trimmedValue, 10) <= 0) {
            fieldErrors.waClawback = "Amount must be greater than zero";
          } else if (
            Number(trimmedValue) >
            Number(creditsToRupees(columnData?.waBalance || 0))
          ) {
            fieldErrors.waClawback =
              "Clawback cannot exceed current WhatsApp balance";
          }
          break;

        default:
          break;
      }
    }

    setErrors((prev) => ({
      ...prev,
      ...fieldErrors,
    }));
  };

  const handleBack = () => {
    handleClose();
    setErrors({});
  };

  const handleAddWaClawback = () => {
    const validationErrors = validate();
    setErrors(validationErrors);

    if (Object.keys(validationErrors).length === 0) {
      const payload = {
        username: loggedInUserName,
        customerCode: columnData?.customerCode || "",
        waUnits: rupeesToCredits(Number(formData.waClawback)) || 0,
      };

      axiosPostApi(apiList.CREATE_CLAWBACK_WA_TOPUP_REQUEST, payload)
        .then((response) => {
          if (response?.status === 200 && response?.data?.status === true) {
            CustomAlert({
              title: response?.data?.message || "WhatsApp Clawback request added successfully",
              icon: "success",
              confirmButtonText: "OK",
              showCloseButton: true,
              allowOutsideClick: false,
            }).then((result) => {
              if (result.isConfirmed) {
                fetchDashboardData();
              }
            });
            callApi();
            handleClose();
          } else if (response?.status === 200 && !response?.data?.status) {
            CustomAlert({
              title: "Failed to Request",
              text: response.data.message,
              icon: "error",
              confirmButtonText: "Retry",
            });
          }
        })
        .catch((error) => {
          console.error("Error processing WhatsApp Clawback request:", error);
          CustomAlert({
            title: "Error",
            text: "An error occurred while adding the WhatsApp Clawback request. Please try again later.",
            icon: "error",
            confirmButtonText: "Retry",
          });
        });
    }
  };

  const fetchDashboardData = () => {
    const endDate = formatDateToYYYYMMDD(new Date());
    const startDate1 = new Date(new Date().setDate(new Date().getDate() - 90));
    const finalStartDate = formatDateToYYYYMMDD(startDate1);

    const requestBody = {
      startDate: finalStartDate,
      endDate: endDate,
      username: loggedInUserName,
    };

    axiosPostApi(apiList.DASHBOARD_DATA, requestBody)
      .then((response) => {
        if (response?.status === 200 && response?.data?.respCode === "00") {
          dispatch(setBalance(response?.data?.data?.balanceDetails));
          callApi(1);
        }
      })
      .catch((error) => {
        console.error("Error fetching SMS overview data", error);
      });
  };

  return (
    <>
      {show && (
        <div
          style={{
            position: "fixed",
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            backgroundColor: "rgba(0,0,0,0.4)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1031,
          }}
        >
          <div className="modal-dialog" role="document">
            <div
              className="modal-content"
              style={{
                width: "550px",
                borderRadius: "24px",
                padding: "24px",
                backgroundColor: "#FFF",
                border: "1px solid rgba(0, 0, 0, 0.175)",
              }}
            >
              <div
                className="modal-header"
                style={{
                  padding: "1rem 1rem",
                  borderBottom: "1px solid #dee2e6",
                }}
              >
                <h5 className="modal-title main-title">Clawback WhatsApp</h5>
              </div>
              <form>
                <div
                  className="scoped-modal modal-body"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    gap: "24px",
                  }}
                >
                  <div className="row mt-2 w-full">
                    <div className="col-12">
                      <div className="row mb-3">
                        <div className="col-md-12">
                          <div className="form-group">
                            <label htmlFor="currentWaBalance">
                              Current WhatsApp Balance (₹)
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              id="currentWaBalance"
                              placeholder="0"
                              value={creditsToRupees(columnData?.waBalance)}
                              style={{
                                textAlign: "right",
                                cursor: "not-allowed",
                              }}
                              readOnly={true}
                            />
                          </div>
                        </div>
                      </div>

                      <div className="row mb-3">
                        <div className="col-md-12">
                          <label htmlFor="waClawback">
                            WhatsApp Clawback (₹)
                          </label>
                          <div className="form-group">
                            <input
                              type="text"
                              className="form-control placeholder:text-sm"
                              id="waClawback"
                              placeholder="Enter WhatsApp units to clawback"
                              value={formData.waClawback || ""}
                              style={{ textAlign: "right" }}
                              onChange={(e) => {
                                const value = e.target.value;
                                if (/^\d{0,9}$/.test(value)) {
                                  handleInputChange(e);
                                }
                              }}
                              onBlur={handleBlur}
                              inputMode="numeric"
                            />
                            {errors.waClawback ? (
                              <span className="error">
                                {errors.waClawback}
                              </span>
                            ) : null}
                          </div>
                        </div>
                      </div>

                      <div className="row mb-3">
                        <div className="col-md-12">
                          <div className="form-group">
                            <label htmlFor="closingWaBalance">
                              Closing WhatsApp Balance (₹)
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              id="closingWaBalance"
                              placeholder="0.00"
                              value={formData?.closingWaBalance || ""}
                              style={{
                                textAlign: "right",
                                cursor: "not-allowed",
                              }}
                              readOnly={true}
                            />
                          </div>
                        </div>
                      </div>

                      <hr />
                    </div>
                  </div>
                </div>

                <div
                  className="scoped-modal mt-2"
                  style={{
                    display: "flex",
                    justifyContent: "end",
                    padding: "12px",
                    paddingTop: "0px",
                    gap: "16px",
                  }}
                >
                  <button
                    type="button"
                    className="btn btn-back"
                    onClick={handleBack}
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    className="btn btn-submit"
                    onClick={handleAddWaClawback}
                  >
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ClawbackWhatsAppModal;
